(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ---- open the submenu on hover (Hamdi 2026-08-16) ----------------------
     Dawn's <header-menu> is click-only. This adds hover on top of it rather
     than replacing it, so keyboard, click and Escape all keep working — the
     only thing that changes is that a pointer over the top-level item sets
     `open` on the same <details> the click would have.

     Gated on `(hover: hover) and (pointer: fine)`: on a touch screen the
     first tap fires a synthetic mouseenter, so a hover-open menu opens and
     closes on the same tap. The width gate matches the one that hides
     header-drawer — below 990px the menu is a drawer and there is nothing to
     hover.

     Closing is delayed ~120ms because the submenu is a sibling panel: moving
     the pointer from the label down into it crosses a gap, and closing on the
     first mouseleave would shut the menu on the way in. */
  (function () {
    var query = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    if (!query.matches) return;

    document.querySelectorAll('.header__inline-menu header-menu > details').forEach(function (details) {
      var timer;

      details.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        details.setAttribute('open', '');
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', function () {
        timer = setTimeout(function () {
          details.removeAttribute('open');
          var summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 120);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltt-bundle-set"]) return;
  try {
    
  if (!customElements.get('ltt-bset')) {
    customElements.define(
      'ltt-bset',
      class extends HTMLElement {
        connectedCallback() {
          const root = this.closest('.ltt-bset');
          this.tablist = root ? root.querySelector('[role="tablist"]') : null;
          this.tabs = this.tablist ? Array.from(this.tablist.querySelectorAll('[role="tab"]')) : [];

          this.onKeydown = this.onKeydown.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index, true));
          });
          if (this.tablist) this.tablist.addEventListener('keydown', this.onKeydown);
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.querySelectorAll('[data-bset-add]').forEach((button) => {
            button.addEventListener('click', () => this.add(button));
          });
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        /* --- tabs (APG, same single-writer shape as ltt-ptabs) -------------- */

        select(index, moveFocus) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) panel.toggleAttribute('hidden', !on);
          });
          if (moveFocus) this.tabs[index].focus();
        }

        onKeydown(event) {
          const current = this.tabs.indexOf(document.activeElement);
          if (current < 0) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          switch (event.key) {
            case 'ArrowRight':
              next = current + (rtl ? -1 : 1);
              break;
            case 'ArrowLeft':
              next = current + (rtl ? 1 : -1);
              break;
            case 'Home':
              next = 0;
              break;
            case 'End':
              next = this.tabs.length - 1;
              break;
            default:
              return;
          }
          event.preventDefault();
          this.select((next + this.tabs.length) % this.tabs.length, true);
        }

        onBlockSelect(event) {
          const tab = event.target.closest ? event.target.closest('[role="tab"]') : null;
          const index = this.tabs.indexOf(tab);
          if (index >= 0) this.select(index, false);
        }

        /* --- add the whole set --------------------------------------------- */

        /* One request, every line. Sending four separate /cart/add calls would
           race each other and repaint the drawer four times; the Ajax API takes
           an items array precisely so it does not have to. */
        add(button) {
          if (button.getAttribute('aria-disabled') === 'true') return;

          const ids = (button.dataset.ids || '').split(',').filter(Boolean);
          if (!ids.length) return;

          const panel = button.closest('.ltt-bset__panel');
          const error = panel ? panel.querySelector('[data-bset-error]') : null;
          const spinner = button.querySelector('.ltt-bset__spinner');
          const cart =
            document.querySelector('cart-notification') || document.querySelector('cart-drawer');

          button.setAttribute('aria-disabled', 'true');
          if (spinner) spinner.classList.remove('hidden');
          if (error) {
            error.hidden = true;
            error.textContent = '';
          }

          const body = new FormData();
          ids.forEach((id, i) => {
            body.append(`items[${i}][id]`, id);
            body.append(`items[${i}][quantity]`, '1');
          });
          if (cart) {
            body.append('sections', cart.getSectionsToRender().map((s) => s.id).join(','));
            body.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
          }

          fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: body,
          })
            .then((response) => response.json())
            .then((data) => {
              // A rejected add answers 422 with `status` + `description`;
              // treating that as success would silently open an empty drawer.
              if (data.status) {
                if (error) {
                  error.textContent = data.description || data.message || '';
                  error.hidden = !error.textContent;
                }
                return;
              }
              if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }
              cart.renderContents(data);
              if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ltt-bundle-set', cartData: data });
              }
            })
            .catch(() => {
              if (error) {
                error.textContent = button.dataset.error || '';
                error.hidden = !error.textContent;
              }
            })
            .finally(() => {
              button.removeAttribute('aria-disabled');
              if (spinner) spinner.classList.add('hidden');
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltt-hero"]) return;
  try {
    
  (() => {
    if (customElements.get('ltt-hero')) return;

    class LttHero extends HTMLElement {
      connectedCallback() {
        if (this._abort) this._abort.abort();
        this.rail = this.querySelector('.ltt-hero__rail');
        const slides = this.rail ? Array.from(this.rail.children) : [];
        if (slides.length < 2) return;

        this._abort = new AbortController();
        const signal = this._abort.signal;
        const dots = Array.from(this.querySelectorAll('.ltt-hero__dot'));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        const interval = Math.max(3000, parseInt(this.dataset.interval, 10) || 5000);
        const holds = new Set();
        let index = 0;
        let timer = null;
        let raf = null;
        // Reduced motion stops the ANIMATION, not the carousel (2026-08-16).
        // Tying autoplay to it meant a phone with Reduce Motion switched on —
        // which is one Accessibility toggle, and common — saw a hero that never
        // changed slide and never played its entrance: the two things Hamdi
        // kept reporting as missing. The slide still changes for those readers;
        // goTo() jumps instead of scrolling (behavior: 'auto' below) and the
        // CSS entrance stays off, so nothing actually moves on screen.
        let playing = this.dataset.autoplay === 'true';

        const rtl = () => getComputedStyle(this).direction === 'rtl';

        // Silent only while genuinely auto-advancing; polite the moment it is
        // paused/held, so a slide the visitor chose is announced.
        const syncLive = () => {
          this.rail.setAttribute('aria-live', playing && holds.size === 0 ? 'off' : 'polite');
        };

        // 2026-08-16: this used to compute an absolute scrollLeft and assume the
        // modern RTL convention (0 → negative). Engines disagree — some run
        // max → 0 — and on those the hero simply never moved: the very first
        // autoplay step clamped, the rail sat still, `data-current` never moved,
        // and the entrance therefore never replayed either. One bug, both
        // symptoms ("no autoplay" and "no animation").
        // A RELATIVE scrollBy of the gap between two live rectangles has no
        // sign convention to get wrong: "put this slide's leading edge on the
        // rail's leading edge" is the same sentence in both directions. Same
        // technique as assets/ltt-carousel.js, which is why every other rail in
        // the theme has always worked in Arabic.
        const goTo = (i, smooth) => {
          const n = slides.length;
          const t = ((i % n) + n) % n;
          const railBox = this.rail.getBoundingClientRect();
          const box = slides[t].getBoundingClientRect();
          const delta = rtl() ? box.right - railBox.right : box.left - railBox.left;
          if (!delta) return;
          // Always smooth unless a caller forces a jump (resize re-align). The
          // reduced-motion query no longer downgrades this — the merchant asked
          // for the slides to glide on every device (2026-08-16).
          this.rail.scrollBy({ left: delta, behavior: smooth === false ? 'auto' : 'smooth' });
        };

        // Which slide is on the leading edge RIGHT NOW. Autoplay steps from
        // this rather than from the `index` variable, because `index` is only
        // refreshed inside a requestAnimationFrame: in a throttled or
        // background tab that callback never runs, `index` goes stale, and the
        // next step then asks for the slide already on screen — which, with the
        // no-op guard in goTo(), stops the carousel for good.
        const measure = () => {
          const railBox = this.rail.getBoundingClientRect();
          const isRtl = rtl();
          const edge = isRtl ? railBox.right : railBox.left;
          let best = 0;
          let bestDist = Infinity;
          slides.forEach((s, j) => {
            const b = s.getBoundingClientRect();
            const d = Math.abs((isRtl ? b.right : b.left) - edge);
            if (d < bestDist) {
              bestDist = d;
              best = j;
            }
          });
          return best;
        };

        const arm = () => {
          clearTimeout(timer);
          if (!playing || holds.size) return;
          timer = setTimeout(() => goTo(measure() + 1), interval);
        };
        const hold = (r) => { holds.add(r); clearTimeout(timer); syncLive(); };
        const release = (r) => { holds.delete(r); syncLive(); arm(); };

        this._teardown = () => {
          clearTimeout(timer);
          if (raf) cancelAnimationFrame(raf);
          if (this._io) this._io.disconnect();
        };

        // Current slide derives from scroll position — native swipe, arrows and
        // autoplay all converge here. Math.abs handles RTL's negative range.
        this.rail.addEventListener('scroll', () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = null;
            const i = measure();
            if (i !== index) {
              index = i;
              dots.forEach((d, j) => {
                if (j === i) d.setAttribute('aria-current', 'true');
                else d.removeAttribute('aria-current');
              });
              // Removing and re-adding the attribute is what RESTARTS the CSS
              // entrance; a class toggled the same way would not, because the
              // rule would already have matched.
              slides.forEach((s, j) => {
                if (j === i) s.setAttribute('data-current', '');
                else s.removeAttribute('data-current');
              });
            }
            arm(); // countdown restarts once the rail settles
          });
        }, { signal, passive: true });

        dots.forEach((d, i) => d.addEventListener('click', () => goTo(i), { signal }));
        const prev = this.querySelector('.ltt-hero__arrow--prev');
        const next = this.querySelector('.ltt-hero__arrow--next');
        if (prev) prev.addEventListener('click', () => goTo(index - 1), { signal });
        if (next) next.addEventListener('click', () => goTo(index + 1), { signal });

        // Pause while interacting: hover, keyboard focus, an active drag.
        this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hold('hover'); }, { signal });
        this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') release('hover'); }, { signal });
        // KEYBOARD focus only. `focusin` on its own froze the carousel for good
        // the first time anyone clicked it: the rail carries tabindex="0", a
        // mouse click focuses it, and nothing ever took the hold back off.
        // :focus-visible is exactly the distinction the browser already makes.
        this.addEventListener('focusin', (e) => {
          const t = e.target;
          if (t && t.matches && t.matches(':focus-visible')) hold('focus');
        }, { signal });
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) release('focus'); }, { signal });
        this.rail.addEventListener('pointerdown', () => hold('drag'), { signal });
        this.rail.addEventListener('pointerup', () => release('drag'), { signal });
        this.rail.addEventListener('pointercancel', () => release('drag'), { signal });

        // Hidden tab / off screen: nothing rotates unseen.
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) hold('hidden'); else release('hidden');
        }, { signal });
        this._io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) release('view'); else hold('view'); });
        }, { threshold: 0.2 });
        this._io.observe(this);

        reduce.addEventListener('change', () => {
          // Only the transition changes with this query now; the countdown is
          // unaffected. Re-armed anyway so a mid-flight timer picks up the new
          // scroll behaviour.
          arm();
        }, { signal });

        // `full` height = viewport minus the real chrome (marquee + header),
        // measured, so the hero's bottom edge lands exactly on the fold.
        const chrome = document.querySelectorAll('.shopify-section-group-header-group');
        const setChromeHeight = () => {
          let h = 0;
          chrome.forEach((s) => { h += s.offsetHeight; });
          this.style.setProperty('--header-height', h + 'px');
        };
        setChromeHeight();

        // Keep the snap aligned across orientation changes.
        window.addEventListener('resize', () => { setChromeHeight(); goTo(index, false); }, { signal });

        // Theme editor: show the selected slide, stop rotating while selected.
        document.addEventListener('shopify:block:select', (e) => {
          const i = slides.indexOf(e.target.closest('.ltt-hero__slide'));
          if (i > -1) { hold('editor'); goTo(i, false); }
        }, { signal });
        document.addEventListener('shopify:block:deselect', (e) => {
          if (this.contains(e.target)) release('editor');
        }, { signal });

        this.classList.add('is-ready');
        syncLive();
        arm();
      }

      disconnectedCallback() {
        if (this._teardown) this._teardown();
        if (this._abort) this._abort.abort();
      }
    }

    customElements.define('ltt-hero', LttHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltt-product-tabs"]) return;
  try {
    
  /* Runs once per page for all instances; the custom element re-upgrades on
     every editor re-render, so no shopify:section:load plumbing is needed. */
  if (!customElements.get('ltt-ptabs')) {
    customElements.define(
      'ltt-ptabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tablist = this.querySelector('[role="tablist"]');
          this.tabs = this.tablist
            ? Array.from(this.tablist.querySelectorAll('[role="tab"]'))
            : [];
          this.onKeydown = this.onKeydown.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);
          if (this.tabs.length === 0) return;

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index, true));
          });
          this.tablist.addEventListener('keydown', this.onKeydown);
          /* Theme editor: selecting a tab block in the sidebar opens its
             panel. Focus is not moved — the merchant is typing over there. */
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        panelFor(tab) {
          return document.getElementById(tab.getAttribute('aria-controls'));
        }

        /* Single writer of tab state: everything derives from `index`, so no
           transition can leave two tabs selected or all at tabindex="-1". */
        select(index, moveFocus) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
            const panel = this.panelFor(tab);
            if (!panel) return;
            // Closed tabs ship their grid inside <template> (zero nodes until
            // asked for). Swap it in BEFORE unhiding, or the first frame of the
            // new tab is an empty panel and the section jumps.
            if (on) {
              const held = panel.querySelector(':scope > template[data-ltt-defer]');
              if (held) held.replaceWith(held.content);
            }
            panel.toggleAttribute('hidden', !on);
          });
          if (moveFocus) this.tabs[index].focus();
        }

        onKeydown(event) {
          const current = this.tabs.indexOf(document.activeElement);
          if (current < 0) return;

          /* In RTL the first tab is the RIGHTMOST one, so ArrowLeft advances
             and ArrowRight goes back. Read the computed direction — the
             storefront may serve ar-EG without touching this markup. */
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;

          switch (event.key) {
            case 'ArrowRight':
              next = current + (rtl ? -1 : 1);
              break;
            case 'ArrowLeft':
              next = current + (rtl ? 1 : -1);
              break;
            case 'Home':
              next = 0;
              break;
            case 'End':
              next = this.tabs.length - 1;
              break;
            default:
              return;
          }

          event.preventDefault();
          /* Wrap at both ends, per the APG example. */
          this.select((next + this.tabs.length) % this.tabs.length, true);
        }

        onBlockSelect(event) {
          if (!this.contains(event.target)) return;
          const tab = event.target.closest('[role="tab"]');
          const index = this.tabs.indexOf(tab);
          if (index >= 0) this.select(index, false);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltt-products"]) return;
  try {
    
  if (!customElements.get('ltt-prodtabs')) {
    customElements.define(
      'ltt-prodtabs',
      class extends HTMLElement {
        connectedCallback() {
          const root = this.closest('.ltt-products');
          this.tablist = root ? root.querySelector('[role="tablist"]') : null;
          this.tabs = this.tablist ? Array.from(this.tablist.querySelectorAll('[role="tab"]')) : [];
          if (!this.tabs.length) return;

          this.onKeydown = this.onKeydown.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);

          this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.select(i, true)));
          this.tablist.addEventListener('keydown', this.onKeydown);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        select(index, moveFocus) {
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.setAttribute('tabindex', on ? '0' : '-1');
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (!panel) return;
            // The closed tab's carousel lives in a <template> and has no nodes
            // yet. Swap it in first: <ltt-carousel> only upgrades once it is in
            // the document, and paintProgress() below needs a rail with a box.
            if (on) {
              const held = panel.querySelector(':scope > template[data-ltt-defer]');
              if (held) held.replaceWith(held.content);
            }
            panel.toggleAttribute('hidden', !on);
            // A panel that was `hidden` has measured zero all this time, so its
            // progress thumb is sized for a rail of width 0. Re-measure the
            // moment it has a box, and start it back at the first card.
            if (on) {
              const car = panel.querySelector('ltt-carousel');
              if (car && car.paintProgress) {
                // A drifting rail has already rotated its own DOM; sending it
                // back to "card 0" would jump it mid-flow for no reason.
                if (!car.flow) car.go(0);
                car.paintProgress();
              }
            }
          });
          if (moveFocus) this.tabs[index].focus();
        }

        onKeydown(event) {
          const current = this.tabs.indexOf(document.activeElement);
          if (current < 0) return;
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          switch (event.key) {
            case 'ArrowRight':
              next = current + (rtl ? -1 : 1);
              break;
            case 'ArrowLeft':
              next = current + (rtl ? 1 : -1);
              break;
            case 'Home':
              next = 0;
              break;
            case 'End':
              next = this.tabs.length - 1;
              break;
            default:
              return;
          }
          event.preventDefault();
          this.select((next + this.tabs.length) % this.tabs.length, true);
        }

        onBlockSelect(event) {
          const tab = event.target.closest ? event.target.closest('[role="tab"]') : null;
          const index = this.tabs.indexOf(tab);
          if (index >= 0) this.select(index, false);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
